export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const getToken = () => {
    const data = localStorage.getItem('access_token');
    return data || null;
}

export const getProject = () => {
    const data = localStorage.getItem('project');
    return data || null;
}

export const setToken = (token, project) => {
    if (token && project) {
        localStorage.setItem('access_token', token);
        localStorage.setItem('project', project);
    }
    return !!token;
}

export const removeToken = () => {
    const data = localStorage.getItem('access_token');
    if (data) {
        localStorage.removeItem('access_token');
    }
}

export const icons = {
    heychina: './heychina.png',
    hanzii: './ic_logo.ico',
    heyjapan: './ic_logo_small.png',
    easyjapanese: './icon-easy.png',
    mazii: './mazii-logo.webp'
}